export type TrainingCourseModel = {
  audience_id: number,
  audience_type: string,
  cache_key: number,
  id: number,
  title: string,
}

export type TrainingCourseRequestOptions = {
  include_training_modules_count: boolean,
}

const state = {
  audience_id: undefined,
  audience_type: '',
  id: null,
  title: '',
}

export const requiredFields = [
  { key: 'title' },
]

export default state
